import common from './common.json';

const merge = Object.assign(
  {},
  common,
);
export default merge;
